/* Navbar dropdown menu's */

export default function initDropdown() {
	let nav = document.querySelector(".js-header-nav");
	let header = document.querySelector(".header");
	if(nav != null){
		let links = nav.getElementsByTagName("a");

		[].forEach.call(links, (element) => {
			// adds chevron down to links with submenu
			let submenu = element.nextElementSibling;
			if (submenu !== null) {
				var chevron = document.createElement("i");
				chevron.classList.add("icon-arrow-down");
				element.appendChild(chevron);
			}

			element.addEventListener("click", (event) => {
				let submenu = element.nextElementSibling;
				function outsideListener(e) {
					if (submenu.contains(e.target)) {
						// clicked inside dropdown
					} else {
						header.style.backgroundColor = "rgba(0, 0, 0, 0.84)";
						submenu.classList.toggle("sub-menu--active");
						window.removeEventListener("click", outsideListener);
					}
				}

				if (submenu !== null) {
					event.preventDefault();
					event.stopPropagation();
					
					header.style.backgroundColor = "rgba(0, 0, 0, 0.84)";
					submenu.classList.toggle("sub-menu--active");

					// listen for all clicks outside dropdown
					window.addEventListener("click", outsideListener);
				} else {
					// console.log("swupped");
				}
			});
		});
	}
}
